import React from 'react';
import { NavLink } from 'react-router-dom';
import useLinkProps from '../../hooks/useLinkProps';
import useTabStyles from './useTabStyles';
export const Tab = ({ to, ariaCurrent = 'page', styles, isActive = false, activeStyles, children, inverted = false }) => {
    const { isHovered, isFocused, ...rest } = useLinkProps(to, children);
    const tabStyles = useTabStyles({ isHovered, isFocused, inverted, styles, activeStyles });
    const showActiveStyles = React.useMemo(() => {
        if (typeof isActive === 'function') {
            return isActive();
        }
        return isActive;
    }, [isActive]);
    return (React.createElement(NavLink, { to: 'to' in rest ? rest.to : rest.href, "aria-current": ariaCurrent, style: (navData) => ({
            ...tabStyles.style,
            ...((showActiveStyles || navData.isActive) && { ...tabStyles.activeStyle })
        }), ...rest }));
};
export default Tab;
//# sourceMappingURL=index.js.map